
namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    export class ClientFieldGrid extends SiteEntityGrid<ClientFieldRow, any> {
        protected getColumnsKey() { return 'Data.ClientField'; }
        protected getDialogType() { return ClientFieldDialog; }
        protected getIdProperty() { return ClientFieldRow.idProperty; }
        protected getLocalTextPrefix() { return ClientFieldRow.localTextPrefix; }
        protected getService() { return ClientFieldService.baseUrl; }

        private schemaAndTable: Serenity.LookupEditor;
        private rowSelection: Serenity.GridRowSelectionMixin;

        constructor(container: JQuery) {
            super(container);

            this.schemaAndTable = Serenity.Widget.create({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey: ClientTableRow.lookupKey,
                    inplaceAdd: true
                },
                init: ed => {
                    ed.element.nextAll('.inplace-button').css({
                        'margin-right': '6px',
                        'position': 'relative',
                        'top': '2px',
                        'height': '28px',
                        'width': '25px'
                    });

                    var item = ClientTableRow.getLookup().items[0];
                    if (item)
                        ed.value = "[" + item.TableSchema + "].[" + item.Tablename + "]";
                },
                element: el => el.attr('placeholder', '-- Select Table --')
                    .css('float', 'left')
                    .css('margin-right', 0)
                    .css('width', '400px')
                    .insertAfter(this.toolbar.element.find('.s-QuickSearchBar'))
            });

            this.schemaAndTable.change(e => {
                this.view.setItems([], true);
                this.refresh()
            });

            this.rowSelection = new Serenity.GridRowSelectionMixin(this);
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.splice(0, 0, Serenity.GridRowSelectionMixin.createSelectColumn(() => this.rowSelection));
            return columns;
        }

        getButtons() {
            var buttons = super.getButtons();
            var addIndex = Q.indexOf(buttons, x => x.cssClass == "add-button");
            buttons[addIndex].title = 'Add Field';
            
            buttons.splice(addIndex + 1, 0, {
                cssClass: 'parse-table-button',
                icon: 'fa-eye',
                title: 'Update From DB',
                onClick: () => {

                    if (!this.tableName) {
                        Q.notifyWarning("Please select a table!");
                        return;
                    }

                    Q.confirm("This will update table fields from DB and might result in losing some client fields defined here, continue?", () => {
                        ClientTableService.Parse({
                            TableSchema: this.tableSchema,
                            Tablename: this.tableName
                        }, r => {
                            this.refresh();
                            Q.notifySuccess("Table fields are updated from DB");
                        });
                    });
                }
            });

            buttons.splice(addIndex + 2, 0, {
                cssClass: 'restart-button',
                icon: 'fa-power-off text-red',
                title: 'Restart',
                onClick: () => {
                    ExtensionFieldService.Restart({}, response => Q.notifyInfo("Application is restarting..."));
                }
            });

            buttons.splice(addIndex + 3, 0, {
                cssClass: 'delete-selected-button',
                icon: 'fa-trash-o text-red',
                title: 'Delete Selected',
                onClick: () => {
                    var keys = this.rowSelection.getSelectedAsInt32();
                    if (!keys.length) {
                        Q.notifyWarning("Please select some fields to delete!");
                        return;
                    }

                    Q.confirm("Delete selected " + keys.length + " fields? (this will also delete underlying table fields if any)", () => {

                        ClientFieldService.BatchDelete({
                            RowIds: keys,
                        },
                            response => {
                                Q.notifySuccess("Selected " + keys.length + " field(s) are deleted.");
                                this.rowSelection.clear();
                                this.refresh();
                            });
                    });
                }
            });

            if (!Authorization.userDefinition.IsDevelopment)
                buttons = buttons.filter(x => x.cssClass != "add-button" && 
                    x.cssClass != "restart-button" &&
                    x.cssClass != "parse-table-button");

            return buttons;
        }

        protected addButtonClick() {
            if (!this.tableName) {
                Q.notifyWarning("Please select a table first!");
                return;
            }

            this.editItem(<ClientFieldRow>{
                TableSchema: this.tableSchema,
                Tablename: this.tableName
            });
        }

        protected getInitialTitle() {
            return "Client Tables";
        }

        private get tableSchema() {
            return Q.replaceAll(Q.replaceAll(this.schemaAndTable.value || '', '[', ''), ']', '').split('.')[0];
        }

        private get tableName() {
            return Q.replaceAll(Q.replaceAll(this.schemaAndTable.value || '', '[', ''), ']', '').split('.')[1];
        }

        getGridCanLoad() {
            return super.getGridCanLoad() && !Q.isEmptyOrNull(this.schemaAndTable.value);
        }

        onViewSubmit() {
            if (!super.onViewSubmit())
                return false;

            var request = this.view.params as Serenity.ListRequest;
            request.EqualityFilter = request.EqualityFilter || {};
            request.EqualityFilter[ClientFieldRow.Fields.TableSchema] = this.tableSchema;
            request.EqualityFilter[ClientFieldRow.Fields.Tablename] = this.tableName;

            return true;
        }

        usePager() {
            return false;
        }
    }
}